import { render, staticRenderFns } from "./FormsSetupFeature.vue?vue&type=template&id=400a6108&"
import script from "./FormsSetupFeature.vue?vue&type=script&lang=js&"
export * from "./FormsSetupFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports